import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowForwardIos } from 'react-icons/md';
import LandinPix from '../Assets/Image/Landingpix.png';

export function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className=''>
      <div className=' grid md:grid-cols-2 gap-[3rem] mx-auto mt-8 md:mt-24 max-w-[1440px] overflow-visible h-fit font-pin items-center'>
        <div className='px-4 sm:px-10 lg:pl-20 flex flex-col gap-6 md:gap-11 w-full col-span-1 justify-center'>
          <h1 className='text-[1.5rem] md:text-[1.8rem] lg:text-[2.5rem] font-semibold leading-tight w-full sm:w-[350px]'>
            Leading EMI and payment solution provider
          </h1>
          <p className='leading-loose max-w-lg'>
            We are the best and trusted social platform that enables users to
            exchange currencies, pay for products and services from stores and
            other businesses around the world
          </p>
          <div className=' flex flex-row gap-6 w-full'>
            <button
              className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-2 md:px-4 lg:px-12 py-3  h-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md relative'
              onClick={() => navigate('/signin')}
            >
              Get Started
            </button>
            <button
              className='text-p-bk justify-center hover:text-b-mc/75 focus:text-b-mc/80 disabled:text-f-bk py-3 px-2 md:px-4 lg:px-12 font-semibold disabled:bg-b-mct rounded-md h-fit flex flex-row gap-4 items-center'
              onClick={() => navigate('/signup')}
            >
              Sign up{' '}
              <span className='rounded-md text-sm'>
                <MdArrowForwardIos />
              </span>
            </button>
          </div>
        </div>
        <img
          src={LandinPix}
          alt='Landing page img'
          className='col-span-1 max-w-3x w-full shadow-lg rounded-lg'
        />
      </div>
    </section>
  );
}
